"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { cn } from "@/lib/utils";

// Rol-switch naar het prototype (Fans / Leden), onder de topbar. Fans = het
// publieke deel. Leden is fase 4 (login), leidt nu naar een 'binnenkort'-pagina.
export function RoleToggle() {
  const pad = usePathname();
  const ledenActief = pad.startsWith("/leden");

  return (
    // Plakt vast onder de topbar: 3.5rem plus de veilige zone die de topbar
    // bovenin vrijhoudt op een iPhone; zie site-topbar.tsx.
    <div className="sticky top-[calc(3.5rem+env(safe-area-inset-top))] z-40 border-b-2 border-primary bg-card">
      <div className="flex px-4">
        <Pill href="/" label="Fans" actief={!ledenActief} />
        <Pill href="/leden" label="Leden" actief={ledenActief} />
      </div>
    </div>
  );
}

function Pill({ href, label, actief }: { href: string; label: string; actief: boolean }) {
  return (
    <Link
      href={href}
      className={cn(
        "relative flex-1 py-3 text-center font-display text-lg font-black uppercase tracking-tight transition-colors",
        actief ? "text-white" : "text-white/40 hover:text-white/70",
      )}
    >
      {label}
      {actief && <span className="absolute inset-x-0 bottom-0 h-1 bg-primary" aria-hidden />}
    </Link>
  );
}
